import { useState } from 'react';
import { CircleX } from 'lucide-react';

import Error from '@/components/common/Error';

import ImageUploader from './ImageUploader';

import { useDeleteCoachProfileImage, useCoachSelf } from '@/data/coach';

const EditImages = () => {
  const [error, setError] = useState();
  const coach = useCoachSelf();
  const deleteCoachProfileImage = useDeleteCoachProfileImage();

  const handleDeleteImage = async (id) => {
    try {
      deleteCoachProfileImage(id);
      coach.mutate(
        (currentCoach) => ({
          ...currentCoach,
          profileImages: currentCoach.profileImages.filter(
            (image) => image.id !== id
          )
        }),
        false
      );
    } catch (err) {
      setError(err);
    }
  };

  const handleSuccess = () => {
    coach.mutate();
  };

  return (
    <>
      <div className="relative p-1 pb-2">
        <div className="grid grid-cols-3 gap-2 p-4">
          {coach.data.profileImages.map((image) => (
            <div
              className="relative flex justify-center items-center"
              key={image.id}
              style={{ aspectRatio: '1 / 1' }}
            >
              <img
                src={image.imageUrlThumb}
                alt="coach"
                className="w-full h-full object-cover rounded-sm"
              />
              <div
                onClick={() => handleDeleteImage(image.id)}
                className="absolute left-[-6px] top-[-6px] text-[var(--primary-white)] bg-[var(--secondary-dark-campfire)] rounded-full w-6 h-6 flex justify-center items-center"
              >
                <CircleX />
              </div>
            </div>
          ))}
          <div
            className="flex justify-center items-center overflow-hidden rounded-sm border"
            style={{ aspectRatio: '1 / 1' }}
          >
            <ImageUploader
              setError={setError}
              coach={coach.data}
              onSuccess={handleSuccess}
            />
          </div>
        </div>
      </div>
      {error && <Error error={error} />}
    </>
  );
};

export default EditImages;
